import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Menu from './menu';

const NavItem = (props) => {
  return (
    <div className={ classNames('post-login-nav-item-component', props.className) } onMouseEnter={ props.onMouseEnter } onMouseLeave={ props.onMouseLeave }>
      {props.href
        ? <a href={ props.href }>{ props.label }</a>
        : <span className="dropdown">{ props.label }</span>
      }
      { props.children }
    </div>
  );
};

NavItem.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType ([
    PropTypes.shape({
      menu: PropTypes.instanceOf(Menu)
    }),
    PropTypes.bool
  ]),
  className: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};

export default NavItem;
